import React from "react";

const paragraph = {
    fontSize: "1.2em",
    marginBottom: "1.5em"
};

const PrePaymentNotice = ({cancellationFeeValue}) => (
    <div
        style={{
            lineHeight: 1.3
        }}
    >
        <h2
            style={{
                ...paragraph,
                fontSize: "22px",
                color: "#D75094",
                fontWeight: 600,
                lineHeight: 1.2,
                marginBottom: "3ex"
            }}
        >
            Important Information: when we could charge you for your appointment
        </h2>

        <p
            style={{
                ...paragraph,
                marginBottom: "1em"
            }}
        >
            Before you confirm your booking, we need to collect payment card
            details.
        </p>

        <p
            style={{...paragraph,
                fontWeight: 600,
                marginBottom: "1em"
            }}
        >
            Payment card details are taken in case you become liable for any
            costs in relation to your treatment. This could be for the following
            reasons:
        </p>

        <p style={paragraph}>
            If you have an excess on your policy or if you exceed any policy
            benefit limits; your insurer will advise us of this and we will take
            payment from you to cover this.
        </p>

        <p style={paragraph}>
            If your insurance policy is cancelled, lapsed, or expires and you
            continue to receive treatment, you will be responsible for the costs
            of the treatment from the point of no cover.
        </p>

        <p style={paragraph}>
            If you cancel an appointment and fail to give 24 hours’ notice that
            you are unable to attend, or if you do not attend an appointment,
            you may be charged a no show fee of £{cancellationFeeValue}, this is not covered by your
            insurance policy, so is passed onto you.
        </p>

        <p style={paragraph}>
            To streamline your onward journey, we would like to validate a
            payment card, that we will hold securely and only use if one of the
            above scenarios occur during your treatment with us. To validate
            your card a £1 validation transaction is processed, however, this
            will be refunded back to you, by IPRS Health.
        </p>

        <p style={paragraph}>
            If IPRS Health do debit your card, we always provide you with 5
            workings days’ notice, by email. The email will state the reasons
            why we need to debit the card, the amount, and our contact details
            in case you have any questions.
        </p>

        <p style={paragraph}>
            Please provide the card details below that you would like IPRS
            Health to validate.
        </p>
    </div>
);

export default PrePaymentNotice;